import React from 'react';
export function flattenChildren(children) {
    return React.Children.toArray(children)
        .reduce(function (flatChildren, child) {
        if (child && child.type === React.Fragment) {
            return flatChildren.concat(flattenChildren(child.props.children));
        }
        flatChildren.push(child);
        return flatChildren;
    }, [])
        .filter(function (c) { return c !== undefined && c !== null && c !== ''; });
}
